module.exports = __webpack_public_path__ + "img/Search Icon - white.1cb75fb4.svg";